import ViewApplication from "pages/BaseApplication/ViewApplication"
import React, { useEffect, useState } from "react"
import { Row } from "reactstrap"

const RotterdamDetails = props => {
  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Registration Number</td>
              <td>
                {props.appDetails.rotterdam_convention.registration_number}
              </td>
            </tr>

            <tr>
              <td>Importing /Exporting Country</td>
              <td>{props.appDetails.rotterdam_convention.state_of_dispatch}</td>
            </tr>

            <tr>
              <td>Chemical Common Name</td>
              <td>
                {props.appDetails.rotterdam_convention.chemical_common_name}
              </td>
            </tr>

            <tr>
              <td>
                Chemical name according to an internationally recognized
                nomenclature (e.g. IUPAC)
              </td>
              <td>
                {
                  props.appDetails.rotterdam_convention
                    .chemical_international_name
                }
              </td>
            </tr>

            <tr>
              <td>CAS Number</td>
              <td>{props.appDetails.rotterdam_convention.cas_number}</td>
            </tr>

            <tr>
              <td>Is this chemical under annex 3 of Rotterdam convention?</td>
              <td>{props.appDetails.rotterdam_convention.is_annex3? "Yes": "No"}</td>
            </tr>

            <tr>
              <td>Harmonized system customs code</td>
              <td>{props.appDetails.rotterdam_convention.harmonized_code}</td>
            </tr>

            <tr>
              <td>Quantity measure</td>
              <td>
                {props.appDetails.rotterdam_convention.quantity_measure.name}
              </td>
            </tr>

            <tr>
              <td>Quantity</td>
              <td>{props.appDetails.rotterdam_convention.quantity}</td>
            </tr>

            <tr>
              <td>Trade Name</td>
              <td>{props.appDetails.rotterdam_convention.trade_name}</td>
            </tr>

            <tr>
              <td>
                For each substance in the preparation that is subject to the
                export notification, concentration (%) and information as
                specified under SECTION 1For each substance in the preparation
                that is subject to the export notification, concentration (%)
                and information as specified under SECTION 1 For each substance
                in the preparation that is subject to the export notification,
                concentration (%) and information as specified under SECTION 1
              </td>
              <td>
                {
                  props.appDetails.rotterdam_convention
                    .description_identity_preparation
                }
              </td>
            </tr>

            <tr>
              <td>Expected date of export</td>
              <td>
                {props.appDetails.rotterdam_convention.expected_date_of_export}
              </td>
            </tr>

            <tr>
              <td>Foreseen category</td>
              <td>{props.appDetails.rotterdam_convention.foreseen_category}</td>
            </tr>

            <tr>
              <td>Name of Exporter/Importer</td>
              <td>{props.appDetails.rotterdam_convention.name_of_importer}</td>
            </tr>

            <tr>
              <td>Address</td>
              <td>{props.appDetails.rotterdam_convention.address}</td>
            </tr>

            <tr>
              <td>Email</td>
              <td>{props.appDetails.rotterdam_convention.email}</td>
            </tr>

            <tr>
              <td>Telephone</td>
              <td>{props.appDetails.rotterdam_convention.telephone}</td>
            </tr>

            <tr>
              <td>Fax</td>
              <td>{props.appDetails.rotterdam_convention.fax}</td>
            </tr>

            <tr>
              <td>Hazard Classification</td>
              <td>
                {props.appDetails.rotterdam_convention.hazard_classification}
              </td>
            </tr>
            <tr>
              <td>Information on Precautionary </td>
              <td>
                {props.appDetails.rotterdam_convention.information_on_hazards}
              </td>
            </tr>

            <tr>
              <td>Information on Precautionary </td>
              <td>
                {props.appDetails.rotterdam_convention.information_on_hazards}
              </td>
            </tr>

            <tr>
              <td>
                Further information that may be useful to the importing country
                or has been requested by it, if available
              </td>
              <td>
                {props.appDetails.rotterdam_convention.additional_information}
              </td>
            </tr>
            <tr>
              <td>Reference</td>
              <td>{props.appDetails.rotterdam_convention.reference}</td>
            </tr>

            <tr>
              <td>Summary information</td>
              <td>
                {props.appDetails.rotterdam_convention.summary_information_physio}
              </td>
            </tr>

            <tr>
              <td>
                The final regulatory action has been taken for the category
              </td>
              <td>{props.appDetails.rotterdam_convention.category}</td>
            </tr>

            <tr>
              <td>Reference to the regulatory document</td>
              <td>
                {
                  props.appDetails.rotterdam_convention
                    .reference_to_regulatory_document
                }
              </td>
            </tr>

            <tr>
              <td>DNA Exporting Country</td>
              <td>{props.appDetails.rotterdam_convention.dna_country}</td>
            </tr>
            <tr>
              <td>DNA Address</td>
              <td>{props.appDetails.rotterdam_convention.dna_address}</td>
            </tr>
            <tr>
              <td>DNA Email</td>
              <td>{props.appDetails.rotterdam_convention.dna_email}</td>
            </tr>

            <tr>
              <td>DNA Fax</td>
              <td>{props.appDetails.rotterdam_convention.dna_fax}</td>
            </tr>
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default RotterdamDetails
